<template>
  <v-card class="mx-auto" :loading="loading" max-width="600">
    <v-card-text v-if="name">
      <img
        v-if="portrait_url"
        max-width="100%"
        :src="portrait_url"
        :alt="name"
      />
      <v-card-title>{{ name }}</v-card-title>

      <v-tabs v-model="tab" show-arrows center-active>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>

        <v-tab-item><character-implants /></v-tab-item>
        <v-tab-item><character-skills /></v-tab-item>
        <v-tab-item><character-loyalty /></v-tab-item>
      </v-tabs>
    </v-card-text>
    <v-card-text v-else>
      <p>Please <a :href="login_url">login</a> to access your character sheet.</p>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import characterRepository from "@/services/characterRepository";
import CharacterImplants from "@/components/character/implants";
import CharacterSkills from "@/components/character/skills";
import CharacterLoyalty from "@/components/character/loyalty";

export default {
  name: "Character",
  components: { CharacterImplants, CharacterSkills, CharacterLoyalty },
  data() {
    return {
      loading: false,
      portrait_url: null,
      items: [
        "Implants",
        "Skills",
        "Loyalty"
      ],
      tab: "Implants"
    };
  },
  computed: {
    ...mapState({
      name: "character_name",
      character_id: "character_id",
      login_url: "login_url"
    })
  },
  methods: {
    setPortrait() {
      if (!this.character_id) return;
      characterRepository.getPortrait(this.character_id).then(url => {
        this.portrait_url = url;
      });
    }
  },
  created() {
    this.setPortrait();
  }
};
</script>
